import React from 'react';
import { Link } from 'react-router-dom';
import { YoutubeIcon } from 'lucide-react';
import { navLinks, youtubeId } from '../data/site';
export function Footer() {
  return <footer className="border-t border-paper/10 bg-ink" data-id="element-11" data-mp="32nun0sijob3h">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-[1.4fr_1fr_1fr] md:px-8" data-id="element-12" data-mp="32pfg0dp7nlz8">
        <div data-id="element-13" data-mp="36ppk1ktg02bg">
          <p className="font-display text-4xl uppercase" data-id="element-14" data-mp="36nd75m2jki59">
            Télép<span className="text-signal" data-id="element-15" data-mp="3ugbs3c3g5mlg">homme</span>
          </p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-paper/60" data-id="element-16" data-mp="38h81hlebwon">
            Le tribute consacré à Téléphone. Sur scène depuis 2012, plus de 200 dates partout en France.
          </p>
        </div>
        <div data-id="element-17" data-mp="3qcnk4sawkozo">
          <h2 className="text-sm font-semibold text-paper" data-id="element-18" data-mp="3qcdux6xomlv1">Le site</h2>
          <ul className="mt-4 space-y-2" data-id="element-19" data-mp="29zgo8ajmtaqv">
            {navLinks.map(l => <li key={l.to} data-id="element-20" data-mp="2a1jhr4jztm0c">
                <Link to={l.to} className="text-sm text-paper/60 transition-colors duration-150 hover:text-paper" data-id="element-21" data-mp="2eyjs3rnvlax9">
                  {l.label}
                </Link>
              </li>)}
          </ul>
        </div>
        <div data-id="element-22" data-mp="3gbqy0fcwslaw">
          <h2 className="text-sm font-semibold text-paper" data-id="element-23" data-mp="3gca7r8seo3du">Booking</h2>
          <Link to="/contact" className="mt-4 inline-block text-sm text-paper/60 transition-colors duration-150 hover:text-paper" data-id="element-24" data-mp="3v8rfzr5at1w6">
            Demander une date
          </Link>
          <a href={`https://www.youtube.com/watch?v=${youtubeId}`} target="_blank" rel="noreferrer" className="mt-3 flex items-center gap-2 text-sm text-paper/60 transition-colors duration-150 hover:text-paper" data-id="element-25" data-mp="81pdrea6qp79">
            <YoutubeIcon className="h-4 w-4" data-id="element-26" data-mp="ctgw51j6tomb" /> YouTube
          </a>
        </div>
      </div>
      <div className="border-t border-paper/10" data-id="element-27" data-mp="qt05tyrnd80q">
        <p className="mx-auto max-w-7xl px-5 py-6 text-xs text-paper/40 md:px-8" data-id="element-28" data-mp="qtro67w8h992">
          © 2026 Téléphomme. Tribute non officiel, en hommage au groupe Téléphone.
        </p>
      </div>
    </footer>;
}